export default {
    ANSWER: [
        "очень слабый пароль",
        "слабый пароль",
        "пароль средней сложности",
        "сильный пароль",
        "очень сильный пароль"
    ]
};
